'use strict';

exports.__esModule = true;

var _utils = require('../utils');

exports.default = {
  computed: {
    $t: function $t() {
      var name = this.$options.name;
      // eslint-disable-next-line

      var prefix = name ? (0, _utils.camelize)(name) + '.' : '';
      var messages = this.$vuiMessages[this.$vuiLang];

      return function (path) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var message = (0, _utils.get)(messages, prefix + path) || (0, _utils.get)(messages, path);
        // eslint-disable-next-line
        return typeof message === 'function' ? message.apply(null, args) : message;
      };
    }
  }
}; // component mixin


//////////////////
// WEBPACK FOOTER
// ./node_modules/@tuniu/dpl-vui/lib/mixins/i18n.js
// module id = 478
// module chunks = 22